import React from "react";

import { LOGIN_TOUR } from "App/Routes";

import { slide as Menu } from "react-burger-menu";

import {
  SHOW_CHALLENGE_CATEGORIES,
  SHOW_TOPIC_CATEGORIES,
  ENABLE_TOUR,
} from "config";
import TopbarMenu from "components/Topbar/TopbarMenu/TopbarMenu";

import packageJson from ".././../../../package.json";
global.appVersion = packageJson.version;

/**
 * CUSTOM FOR GRAB: Right Sidebar Menu
 * - Revise copywriting for "About" (Tour)
 * - Add additional FAQ link
 */
class GrabTopbarMenu extends TopbarMenu {
  /**
   * Renders tour link
   * Custom for Grab: Custom Text
   */
  renderAboutTourItem() {
    if (this.props.state !== "login-tour" && ENABLE_TOUR) {
      return (
        <a
          className="menu-item link"
          onClick={(e) => {
            this.props.handleHideMenu();
            this.props.handleOpenTourModal(e);
          }}
          href={LOGIN_TOUR}
        >
          <i className="fas fa-info-circle" />
          <span>Quick Tour</span>
        </a>
      );
    } else {
      return null;
    }
  }

  /**
   * Custom for Grab: Render FAQ Link
   */
  renderFAQItem() {
    return (
      <a
        className="menu-item link"
        href="https://go.grab.com/cybergamification"
        target="_blank"
        rel="noreferrer"
      >
        <i className="fas fa-question-circle" />
        <span>FAQ</span>
      </a>
    );
  }

  /**
   * Renders the menu
   */
  render() {
    let showChallengeCategories =
      (this.props.state === "topic" ||
        this.props.state === "topic-comments-thread" ||
        this.props.state === "challenge-category") &&
      this.props.topic &&
      Array.isArray(this.props.topic.categories) &&
      this.props.topic.categories.length > 0;

    let showFirstDivider = SHOW_CHALLENGE_CATEGORIES
      ? showChallengeCategories
      : false;

    let showTopicCategories =
      (this.props.state === "projecthome" ||
        this.props.state === "home-single" ||
        this.props.state === "topic-category") &&
      this.props.project &&
      Array.isArray(this.props.project.categories) &&
      this.props.project.categories.length > 0;

    let showTopicsList =
      this.props.project &&
      Array.isArray(this.props.topicsList) &&
      this.props.topicsList.length > 0;

    let showSearchChallenges =
      this.props.project &&
      this.props.project.challengeSearchEnabled &&
      !this.props.isMobileProjectPage === true;

    let showShareGame =
      this.props.project &&
      this.props.project.projectShareLink &&
      this.props.projectId;

    let showReferAFriend =
      this.props.project &&
      this.props.project.projectReferralLink &&
      (this.props.state === "projecthome" ||
        this.props.state === "home-single" ||
        this.props.state === "topic-category" ||
        this.props.state === "project" ||
        this.props.state === "topic" ||
        this.props.state === "topic-comments-thread" ||
        this.props.state === "challenge" ||
        this.props.state === "challenge-category" ||
        this.props.state === "challenge-comments" ||
        this.props.state === "challenge-comments-thread" ||
        this.props.state === "challenge-subpage" ||
        this.props.state === "claim-comments" ||
        this.props.state === "claim-comments-thread");

    /* The pages below (this.props.state) have a route to original Project */
    let showBackToProject =
      this.props.projectId &&
      (this.props.state === "topic" ||
        this.props.state === "topic-comments-thread" ||
        this.props.state === "challenge" ||
        this.props.state === "project" ||
        this.props.state === "topic-category" ||
        this.props.state === "challenge-category" ||
        this.props.state === "challenge-comments" ||
        this.props.state === "challenge-comments-thread" ||
        this.props.state === "challenge-subpage" ||
        this.props.state === "claim-comments" ||
        this.props.state === "claim-comments-thread" ||
        this.props.state === "login-tour");

    let showSecondDivider = SHOW_TOPIC_CATEGORIES
      ? showSearchChallenges ||
        showShareGame ||
        showBackToProject ||
        showTopicCategories
      : showSearchChallenges || showShareGame || showBackToProject;

    let projectTitle = this.props.project ? this.props.project.title : "";

    return (
      <Menu
        isOpen={this.props.showMenu}
        handleHideMenu={this.props.handleHideMenu}
        onStateChange={this.toggleMenu}
        styles={this.setStyles()}
        right
      >
        {/* You should be able to select categories without logging in */}
        {this.renderChallengeCategoriesItem(showChallengeCategories)}
        {this.renderDivider(showFirstDivider)}
        {this.renderTopicCategoriesItem(showTopicCategories)}
        {this.renderTopicsListItem(showTopicsList)}
        {/* Logged in links */}
        {this.renderSearchChallengesItem(showSearchChallenges)}
        {this.renderShareGameItem(showShareGame)}
        {this.renderReferAFriendItem(showReferAFriend)}
        {this.renderBackToProjectItem(showBackToProject, projectTitle)}
        {this.renderDivider(showSecondDivider)}
        {this.renderRefreshItem()}
        {this.renderSettingsItem()}
        {this.renderAboutTourItem()}
        {this.renderFAQItem()}
        {this.renderLogoutItem()}
        {/* Logged out links */}
        {this.renderLoginItem()}

        {packageJson.version && this.renderDivider(true)}
        {packageJson.version && this.renderAppVersion()}
      </Menu>
    );
  }
}

export default GrabTopbarMenu;
